module.exports = __webpack_public_path__ + "static/img/carac5.55580b00.jpg";